var map = {
	"./bed_basket.png": 3828,
	"./bed_plush.png": 8380,
	"./costume_bee.png": 4475,
	"./costume_dino.png": 3067,
	"./hat_beanie.png": 8524,
	"./hat_party.png": 3974,
	"./hat_trail_cap.png": 1583,
	"./neck_bandana.png": 1931,
	"./neck_bowtie.png": 7114,
	"./neck_classic.png": 6997,
	"./neck_sport.png": 4988,
	"./plant_bonsai.png": 4446,
	"./plant_fern.png": 9227,
	"./rug_round.png": 831,
	"./rug_striped.png": 9058,
	"./top_hoodie.png": 1134,
	"./top_raincoat.png": 9785,
	"./top_tee.png": 8630,
	"./toy_ball.png": 8906,
	"./toy_rope.png": 5681,
	"./wall_frame.png": 2440,
	"./wall_shelf.png": 9424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7475;